<template>
    <div class="col-md-12">
        {{root}}
        <input type="hidden" name="force_root" v-model="isRoot">
    </div>
</template>

<script>
import mqtt from "mqtt";

export default {
    name: "ScheduleCheckOnline",
    props: {
        scheduleId: {required: true},
        openedId: {required: true},
        forceRoot: {default: false}
    },
    data() {
        return {
            client: {
                connected: false,
            },
            root: null,
            isRoot: true
        }
    },
    methods: {
        doSubscribe(topic, qos = 0) {
            this.client.subscribe(topic, {qos}, (error, res) => {
                if (error) {
                    console.log('Subscribe to topics error', error)
                    return
                }
                console.log('Subscribe to topics res', res)
            })
        },
        async createConnection() {
            var app = this;
            this.client = mqtt.connect('wss://test.mosquitto.org:8081/mqtt', this.options)

            this.client.on('connect', () => {
                console.log('Connection succeeded!')
                app.doSubscribe('can-rams-schedule-' + this.scheduleId)
                if (app.$store.getters['auth/userId'] != app.openedId) {
                    app.client.publish('can-rams-schedule-' + this.scheduleId, JSON.stringify(app.openedId))
                }

            })
            this.client.on('error', error => {
                console.log('Connection failed', error)
            })
            this.client.on('message', (topic, message) => {
                if (`${topic}` === 'can-rams-schedule-' + this.scheduleId) {
                    const arrayBuffer = new TextEncoder().encode(message)
                    let root = JSON.parse(new TextDecoder().decode(arrayBuffer));
                   /* if (app.$store.getters['auth/userId'] == root) {
                        app.client.publish('can-rams-schedule-' + this.scheduleId, JSON.stringify('exists'))
                    }*/

                }
            })
        },
    },
    async mounted() {
        this.$store.commit('schedules/setScheduleId', this.scheduleId)
        this.createConnection()
    }
}
</script>

